/**
 * @generated SignedSource<<b88c7d8959d92c99cd3826a502e76334>>
 * @relayHash b47669aaa2d26c840c41f7ffe677fdee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookListQuery } from './PlaybookListQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6",
    "metadata": {},
    "name": "PlaybookListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
